<template>
  <v-app>
    <v-app-bar v-if="isInVK" app dense flat>
      <v-app-bar-title>Новые Группы &reg;</v-app-bar-title>

      <v-btn exact-path icon to="/">
        <v-icon :icon="mdiViewList" title="Группы" />
      </v-btn>
      <v-btn icon to="/about">
        <v-icon :icon="mdiHelpCircle" title="Помощь" />
      </v-btn>
      <v-btn v-if="!isFavorite" icon @click="addToFavorites">
        <v-icon :icon="mdiHeart" title="Добавить в Избранное" />
      </v-btn>
      <v-btn icon @click="donate">
        <v-icon :icon="mdiCoffee" title="На кофе автору" />
      </v-btn>
    </v-app-bar>    
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup>
  import { mdiCoffee, mdiHeart, mdiHelpCircle, mdiViewList } from '@mdi/js'
  import bridge from '@vkontakte/vk-bridge'
  import { computed, onMounted } from 'vue'
  import router from './router/index.js'
  import { useAppStore } from './stores/app.js'
  import { start } from './vk/engine.js'

  const store = useAppStore();

  const isFavorite = computed(() => store.isFavorite);

  const isInVK = computed(() => Object.keys(store.startParams).length > 0);

  async function addToFavorites () {
    await bridge
      .send("VKWebAppAddToFavorites")
      .then((response) => {
        if (response.result) {
          console.log("We're loved!");
        }
      })
      .catch(console.error);
  }

  async function donate () {
    const app_id = Number(import.meta.env.VITE_VK_APP_ID);
    const user_id = Number(import.meta.env.VITE_VK_OWNER_ID);

    await bridge
      .send("VKWebAppOpenPayForm", {
        app_id,
        action: "pay-to-user",
        params: { user_id },
      })
      .then((response) => {
        if (response.result) {
          console.log("We're loved!");
        }
      })
      .catch(console.error);
  }

  /**
   * Check and save app start parameters.
   * @return {Boolean} true on success, false if not in VK
   */
  function handleStartParameters() {
    // URL params
    const params = Object.fromEntries(
      new URLSearchParams(document.location.search)
    )
    
    /** @see https://dev.vk.com/ru/mini-apps/development/launch-params */
    const requiredKeys = ["sign", "vk_app_id", "vk_user_id", "vk_access_token_settings"];
    
    const missingKeys = requiredKeys.filter((key) => !(key in params)); 
    if (missingKeys.length === 0) {
      store.setStartParams(params);
      return true;
    }
    
    console.error(`[AppVue] params missing: ${missingKeys}`);
    return false;
  }

  async function initBridge() {
    // VK Bridge initialize
    await bridge
      .send("VKWebAppInit", {})
      .then((response) => {
        store.isBridgeInitialized = !!response.result;
      })
      .catch(console.error);

    // TODO: why this exact size?
    const windowSize = { width: 800, height: 1080 };
    await bridge.send("VKWebAppResizeWindow", windowSize)
      .catch(error => {
        console.error(error);
      });

    bridge.subscribe((e) => {
      if (e.detail.type === 'VKWebAppViewHide') {
        console.log('Bridge went OFF');
        store.isBridgeActive = false;
      } else if (e.detail.type === 'VKWebAppViewestore') {
        console.log('Bridge went ON');
        store.isBridgeActive = true;
      }
    });
    
    document.addEventListener("visibilitychange", () => {
      store.isBridgeActive = document.hidden ? false : true;
      console.log(`Bridge went ${store.isBridgeActive ? 'ON' : 'OFF'} by visibilitychange event`);
    });
  }

  onMounted(async () => {
    if (!handleStartParameters()) {
      router.push('/direct');

      return;
    }

    await initBridge();

    // Launch main task chain
    start();
  })
</script>
